import React, { useState, useEffect } from "react";
import {
  Table,
  TableHeader,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  TableCellLayout,
  Button,
  Spinner,
} from "@fluentui/react-components";

import {
  DeleteRegular,
  Add20Filled,
  ArrowDownload20Filled,
} from "@fluentui/react-icons";
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import "../CSS/ListMediaComponent.css";
import { getAccessToken } from "../../Services/GraphServices";
import { deleteMedia ,getAllMedia} from "../../Services/HeedifyServices";
import { ConfirmAlert } from "../GenericComponent/ConfirmAlert";
import { useNavigate } from "react-router-dom";
import { useAbility } from "../../Contexts/AbilityContext";
import { useNotification } from "../GenericComponent/NotificationSystem";
const ListMediaComponent = (props) => {
  const authContext = useMsal();
  let accounts = authContext.accounts;
  let instance = authContext.instance;
  const activeAccount = accounts[0];
  const { t } = useTranslation();
  const navigate = useNavigate();
  const ability = useAbility();
  const { showSuccess, showError } = useNotification();
  const [mediasRows, setMediasRows] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [deletingMediaName, setDeletingMediaName] = useState(null);

  const columns = [
    { columnKey: "MEDIA_NAME", label: t("MEDIA_NAME") },
    { columnKey: "ACTION", label: t("ACTION") },
  ];
  const getAllMedias = ()=>{
    getAccessToken(instance, activeAccount)
         .then((token) => {
           getAllMedia(props.ACTIVE_TENANT, token).then((medias) => {
             // Ajouter scope "default" à chaque média
             const mediasWithScope = medias.map(media => ({
               ...media,
               scope: "default"
             }));
             props.setMedias(mediasWithScope);
          
           });
         });
 }
   const removeMedia = (key, mediaName) => {
     setDeletingMediaName(mediaName);
     getAccessToken(instance, activeAccount)
       .then((token) => {
         return deleteMedia(props.ACTIVE_TENANT, mediaName, token);
       })
       .then((response) => {
         if(response?.success === true) {
           // Mettre à jour Redux pour supprimer le média
           const updatedMedias = props.MEDIAS.filter(media => media.header !== mediaName);
           props.setMedias(updatedMedias);
           
           // Nettoyer les références dans les queues
           if (props.QUEUES && Object.keys(props.QUEUES).length > 0) {
             const updatedQueues = {};
             Object.entries(props.QUEUES).forEach(([queueId, queue]) => {
               const cleanedQueue = { ...queue };
               if (cleanedQueue?.musicOnHold?.includes(mediaName)) {
                 delete cleanedQueue.musicOnHold;
               }
               if (cleanedQueue?.whisperUrl?.includes(mediaName)) {
                 delete cleanedQueue.whisperUrl;
               }
               updatedQueues[queueId] = cleanedQueue;
             });
             props.setQueues(updatedQueues);
           }
           
           // Nettoyer les références dans les callflows
           if (props.CALL_FLOWS && Object.keys(props.CALL_FLOWS).length > 0) {
             const updatedCallFlows = {};
             Object.entries(props.CALL_FLOWS).forEach(([flowId, flow]) => {
               const cleanedFlow = { ...flow };
               if (cleanedFlow?.mediaUrl?.includes(mediaName)) {
                 delete cleanedFlow.mediaUrl;
               }
               if (cleanedFlow?.musicOnHold?.includes(mediaName)) {
                 delete cleanedFlow.musicOnHold;
               }
               if (cleanedFlow?.whisperUrl?.includes(mediaName)) {
                 delete cleanedFlow.whisperUrl;
               }
               updatedCallFlows[flowId] = cleanedFlow;
             });
             props.setCallFlows(updatedCallFlows);
           }
           
           // Nettoyer les références dans les chatflows
           if (props.CHAT_FLOWS && Array.isArray(props.CHAT_FLOWS) && props.CHAT_FLOWS.length > 0) {
             const updatedChatFlows = props.CHAT_FLOWS.map(flow => {
               const cleanedFlow = { ...flow };
               if (cleanedFlow?.mediaUrl?.includes(mediaName)) {
                 delete cleanedFlow.mediaUrl;
               }
               return cleanedFlow;
             });
             props.setChatFlows(updatedChatFlows);
           }
           
           // Mettre à jour l'état local
           setMediasRows((prev) => prev.filter((_, i) => i !== key));
           showSuccess(t("MEDIA_DELETED_SUCCESS"));
         } else {
           showError(t("MEDIA_DELETE_FAILED"));
         }
       })
       .catch((error) => {
         console.error(" Erreur lors de la suppression du média :", error);
         showError(t("MEDIA_DELETE_ERROR"));
       })
       .finally(() => {
         setDeletingMediaName(null);
         setSelectedMedia(null);
       });
   };
 
   const confirmRemoveMedia = (media, index) => {
     setSelectedMedia({ ...media, key: index });
   };

  // 🔐 Filtrer les médias selon permissions.main.canRead
  const filteredRows = mediasRows.filter(media => media.permissions?.main?.canRead);

  // 🔐 Vérifier si on peut créer un média dans au moins un scope
  // Si SCOPES_NAMES n'est pas défini ou vide, autoriser (super admin)
  const hasAnyCreatePermission = !props.SCOPES_NAMES || props.SCOPES_NAMES.length === 0
    ? true
    : props.SCOPES_NAMES.some(scope => ability?.can("create", `Media.main@${scope}`));
  // Charger les médias au montage du composant (une seule fois)
  useEffect(() => {
    getAllMedias();
  }, []); // Dépendances vides = exécuté une seule fois

   useEffect(() => {
    if (props.MEDIAS?.length > 0 && ability) {
      // 🔐 Calculer permissions pour chaque média selon son scope
      const mediasWithPermissions = props.MEDIAS.map(media => {
        const mediaScope = media.scope || "default"; // Utiliser le scope du média
        return {
          ...media,
          permissions: {
            main: {
              canCreate: ability?.can("create", `Media.main@${mediaScope}`),
              canRead: ability?.can("read", `Media.main@${mediaScope}`),
              canUpdate: ability?.can("update", `Media.main@${mediaScope}`),
              canDelete: ability?.can("delete", `Media.main@${mediaScope}`),
            },
          },
        };
      });
      setMediasRows(mediasWithPermissions);
    }
  }, [props.MEDIAS, ability]);

 

  if (filteredRows.length === 0 && mediasRows.length > 0) {
    return (
      <div className="access-denied-message">
        <h2>{t("MEDIA_ACCESS_DENIED")}</h2>
        <p>{t("MEDIA_NO_PERMISSION_TO_VIEW")}</p>
      </div>
    );
  }

  return (
    <>
      <div >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h2>{t("LIST_MEDIA")}</h2>
        <Button
          appearance="primary"
          onClick={() => navigate("/medias/addMedia")}
          disabled={!hasAnyCreatePermission}
        >
          <Add20Filled /> {t("ADD_NEW_MEDIA")}
        </Button>
      </div>

      <div className="media-list-table-container">
        <div  className="media-list-table-wrapper">
          <Table role="grid" aria-label="Media table" className="media-list-table-style">
            {/* HEADER */}
            <TableHeader>
              <TableRow className="media-list-header-style">
                {columns.map((column) => (
                  <TableHeaderCell
                    key={column.columnKey}
                    className={`media-list-cell-bold ${
                      column.columnKey === "ACTION" ? "media-list-cell-right" : ""
                    }`}
                  >
                    {column.label}
                  </TableHeaderCell>
                ))}
              </TableRow>
            </TableHeader>

            {/* BODY scrollable */}
            <TableBody  className="media-list-table-wrapper" >
              {filteredRows.map((media, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <TableCellLayout>{media.header}</TableCellLayout>
                  </TableCell>

                  <TableCell className="media-list-cell-right">
                    
                    <Button
                      appearance="subtle"
                      icon={deletingMediaName === media.header ? <Spinner size="tiny" /> : <DeleteRegular />}
                      aria-label="Delete"
                      onClick={() => confirmRemoveMedia(media, index)}
                      disabled={!media.permissions?.main?.canDelete || deletingMediaName === media.header}
                    />
                    <a href={media.url} download={media.header}>
                      <Button
                      disabled={!media.permissions?.main?.canRead}
                        appearance="subtle"
                        icon={<ArrowDownload20Filled fontSize={20} />}
                        aria-label="Download"
                      />
                    </a>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        </div>

      {selectedMedia && (
        <ConfirmAlert
          open={!!selectedMedia} //if null return false else return true
          name={selectedMedia.header}
          onConfirm={() => removeMedia(selectedMedia.key, selectedMedia.header)}
          onCancel={() => setSelectedMedia(null)}
        />
      )}
      </div>
    </>
  );
};

export default ListMediaComponent;
